import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import ChatbotFixed from './components/ChatbotFixed';
import AdminControlPanel from './components/AdminControlPanel';
import RagManagement from './components/RagManagement';
import GuardrailsManagement from './components/GuardrailsManagement';
import PromptManagement from './components/PromptManagement';
import ConversationHistory from './components/ConversationHistory';
import AutomatedTester from './components/AutomatedTester';
import SimpleTester from './components/SimpleTester';
import AgentDashboard from './components/AgentDashboard';
import AdminDashboard from './components/AdminDashboard';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<ChatbotFixed />} />
          <Route path="/admin/controlpanel" element={<AdminControlPanel />} />
          <Route path="/admin/controlpanel/rag" element={<RagManagement />} />
          <Route path="/admin/controlpanel/guardrails" element={<GuardrailsManagement />} />
          <Route path="/admin/controlpanel/prompts" element={<PromptManagement />} />
          <Route path="/admin/controlpanel/conversations" element={<ConversationHistory />} />
          <Route path="/admin/controlpanel/dashboard" element={<AgentDashboard />} />
          <Route path="/admin/controlpanel/tester" element={<AutomatedTester />} />
          <Route path="/admin/controlpanel/simple-tester" element={<SimpleTester />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;